var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("\n        Logged Out\n    ")]),_c('p',[_vm._v("\n        You have successfully Logged out\n    ")])])
}]

export { render, staticRenderFns }